import React, { useCallback, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useForm, FormProvider } from 'react-hook-form';
import { makeStyles } from '@material-ui/core';
import useRequest from '@hooks/useRequest';
import { RootState } from '@modules/index';
import DesignPrototypingControl from '@routes/NewRequest/FormComponents/DesignPrototypingControl';
import { DesignStepProps, PrototypingRequestForm } from './types';

const DesignPrototypeStep: React.FC<DesignStepProps> = ({
  setDisabledNextButton,
  nextButtonAction
}) => {
  const requestPrototypingDefaultValue = useSelector<
    RootState,
    boolean | null | undefined
  >((state) => state.request.requestPrototyping);
  const prototypeQuantityDefaultValue = useSelector<
    RootState,
    number | null | undefined
  >((state) => state.request.prototypeQuantity);
  const { requestContainer } = useDesignRequestStyles();
  const { onUpdateRfqInfo } = useRequest();
  const formProps = useForm<PrototypingRequestForm>({
    mode: 'onChange',
    defaultValues: {
      prototypeQuantity: prototypeQuantityDefaultValue,
      requestPrototyping: requestPrototypingDefaultValue
    }
  });
  const { watch } = formProps;
  const { prototypeQuantity, requestPrototyping } = watch();
  const currentFormValue = useRef<PrototypingRequestForm>({
    prototypeQuantity,
    requestPrototyping
  });

  const onSubmit = useCallback(() => {
    const currentValue = currentFormValue.current;
    onUpdateRfqInfo({
      ...currentValue
    });
  }, [onUpdateRfqInfo]);

  useEffect(() => {
    currentFormValue.current = {
      prototypeQuantity,
      requestPrototyping
    };
  }, [prototypeQuantity, requestPrototyping]);

  useEffect(() => {
    nextButtonAction.current.DESIGN = onSubmit;
  }, [nextButtonAction, onSubmit]);

  useEffect(() => {
    if (!setDisabledNextButton) return;

    if (requestPrototyping !== null) {
      if (
        requestPrototyping &&
        prototypeQuantity &&
        prototypeQuantity > 0 &&
        prototypeQuantity.toString().length < 20
      ) {
        setDisabledNextButton(false);
        return;
      }

      if (!requestPrototyping) {
        setDisabledNextButton(false);
        return;
      }

      setDisabledNextButton(true);
    } else {
      setDisabledNextButton(true);
    }
  }, [requestPrototyping, prototypeQuantity, setDisabledNextButton]);

  useEffect(() => {
    return onSubmit;
    //eslint-disable-next-line
  }, []);

  return (
    <div className={requestContainer}>
      <FormProvider {...formProps}>
        <form>
          <DesignPrototypingControl />
        </form>
      </FormProvider>
    </div>
  );
};

export default DesignPrototypeStep;

const useDesignRequestStyles = makeStyles((theme) => ({
  requestContainer: {
    width: '100%',
    maxWidth: '464px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '72px',
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0
    }
  }
}));
